import React from 'react';
import { HandshakeIcon, StethoscopeIcon, UsersIcon } from 'lucide-react';
import { CountUp } from './CountUp';
import { trustItems } from '../data/homepage';
const icons = {
  users: UsersIcon,
  medical: StethoscopeIcon,
  oneOnOne: HandshakeIcon
};
export function TrustBar() {
  return <section aria-label="Why veterans trust us" className="on-light border-b border-navy/10 bg-paper" data-id="element-231" data-mp="137als1v8swep">
      <ul className="mx-auto grid max-w-7xl gap-6 px-6 py-8 md:grid-cols-3 md:gap-0 md:divide-x md:divide-gold/50 md:px-10 md:py-10" data-id="element-232" data-mp="1qwv7utmp09s7">
        {trustItems.map(item => {
        const Icon = icons[item.icon];
        return <li key={item.icon} className="flex items-center gap-4 md:justify-center md:px-6" data-id="element-233" data-mp="1gyp569t2azma">
              <Icon aria-hidden="true" className="h-7 w-7 shrink-0 text-navy" strokeWidth={1.5} data-id="element-234" data-mp="1lx0d2ezsr01v" />
              <span className="text-lg font-medium text-navy" data-id="element-235" data-mp="5jabpg02apvx">
                {item.count !== null ? <>
                    {item.before}
                    <strong className="font-semibold" data-id="element-236" data-mp="1aidnzwni3wbq">
                      <CountUp to={item.count} data-id="element-237" data-mp="1aj6vx0y74rvg" />
                    </strong>
                    {item.after}
                  </> : item.before}
              </span>
            </li>;
      })}
      </ul>
    </section>;
}